import { useTranslation } from "react-i18next";
import * as Pages from "@/components/Pages";
import * as Paper from "@/components/PaperContainer";
import * as React from "react";

import { useLoadedData } from "./loader";

import { Form } from "./Form";

import { usePaths } from "@/routes/paths";
export function Page() {
  const { t } = useTranslation();
  const paths = usePaths();
  const { project } = useLoadedData();

  return (
    <Pages.Page title={[t("Resume"), project.name!]}>
      <Paper.Root size="medium">
        <Paper.Navigation items={[{ to: paths.projectPath(project.id!), label: project.name! }]} />

        <Paper.Body minHeight="none">
          <div className="text-content-accent text-3xl font-extrabold">{t("Ready to resume project?")}</div>
          <div className="text-content text font-medium mt-2">
            {t("Resuming will:")}
            <ul className="list-disc list-inside mt-4">
              <li>{t("Reactivate project milestones and tasks")}</li>
              <li>{t("Restart notifications for team members")}</li>
              <li>{t("Make the project visible in active project lists")}</li>
            </ul>
          </div>

          <div className="mt-8">
            <Form project={project} />
          </div>
        </Paper.Body>
      </Paper.Root>
    </Pages.Page>
  );
}
